import { Component, Input } from '@angular/core';
import { NavController, NavParams, Events, Platform, ViewController, PopoverController, MenuController, App } from 'ionic-angular';
import { GlobalvariablesProvider } from '../../providers/globalvariables/globalvariables';
import { SettingsProvider } from '../../providers/settings/settings';
import { SavingsAccountsProvider } from './../../providers/savings-accounts/savings-accounts';

declare var window;

@Component({
  selector: 'consectus-header',
  templateUrl: './header.html',
})
export class HeaderComponent {
  @Input() cameraButton: boolean;
  @Input() mapButton: boolean;
  @Input() helpButton: boolean = false;
  @Input() closeButton: boolean;
  @Input() backButton: boolean = true;
  @Input() appMenu: boolean = true;
  @Input() hideMenuButtoon: any;
  @Input() count: number = 0;

  hideMenu: boolean = false;
  // mapButton: boolean;
  account: any;
  public isNew: boolean = false;
  popover: any;
  goal: any = {
    title: '',
    amount: '',
    target_date: "2017-06-28",
    image: null,
    base_64_image: '',
    account_number: null,
  };
  title: string = "Step One building society";
  constructor(private platform: Platform,
    public navCtrl: NavController,
    public globalProvider: GlobalvariablesProvider,
    public viewCtrl: ViewController,
    private app: App,
    public popoverCtrl: PopoverController,
    public settingsProvider: SettingsProvider,
    public events: Events,
    public savingsAccountsProvider: SavingsAccountsProvider,
    public navParams: NavParams, menu: MenuController) {
    menu.enable(true);
    this.account = navParams.get('account');




    if (this.viewCtrl.name == "ModalCmp") {
      this.hideMenu = !this.hideMenu;
    } else {
      this.hideMenu = false;
    }

    if (this.viewCtrl.name == "FaqCategoryPage") {
      this.helpButton = false;
    }

    if (this.navCtrl.last() !== undefined) {
      if (this.navCtrl.last().name == "LoginFormPage") {
        this.hideMenu = !this.hideMenu;
      }
    }


    /*If platform is android and ios then set back button text*/
    if (this.platform.is('android') || this.platform.is('mobileweb')) {
      this.viewCtrl.setBackButtonText("");
    }

    this.goal = this.globalProvider.savingGoal;
    if (!this.goal) {
      this.isNew = true;
      this.goal = {
        title: '',
        amount: '',
        image: null,
        date: new Date().toISOString(),
        base_64_image: null,
        account_number: this.account == undefined ? "" : this.account.account_number,
      };
    } else {
      this.goal.base_64_image = null;
    }
  }
  showMap() {
    if (this.platform.is("core")) {
      window.top.open('https://www.google.com/maps/place/Consectus+Limited/@51.5196578,-0.7207674,15z/data=!4m5!3m4!1s0x0:0xe5e78e45e1a14e92!8m2!3d51.5196578!4d-0.7207674');
    } else {
      window.top.open('https://www.google.com/maps/place/Consectus+Limited/@51.5196578,-0.7207674,15z/data=!4m5!3m4!1s0x0:0xe5e78e45e1a14e92!8m2!3d51.5196578!4d-0.7207674');
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  help() {
    this.navCtrl.push("FaqCategoryPage", { page: this.navCtrl.last().component.name });
  }

  photo(event) {
    if (this.platform.is("core") === true || this.platform.is("mobileweb")) {
      this.popover = this.popoverCtrl.create("ImageUploadPopoverPage");
    } else {
      this.popover = this.popoverCtrl.create("CameraAlbumPopoverPage", {
        picture: true,
        album: true,
        video: false
      });
    }
    let self = this;
    this.popover.onDidDismiss((data) => {
      if (data) {
        self.goal.image = data.image;

        // self.cdr.detectChanges();
      }
    });
    this.popover.present({
      ev: event
    });

  }



  ionViewWillLeave() {
    if (this.popover) {
      this.popover.dismiss();
    }
  }

  backNavigation() {


    this.app.getRootNav().getActiveChildNav().select(0);
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts